import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Chart } from "chart.js";
import { ChartService } from "src/app/shared/chart.service";
import { UserService } from "src/app/shared/user.service";
import { ContractService } from "../../shared/contract.service";
import { TaskDialogComponent } from "../task-dialog/task-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import * as echarts from 'echarts';
import { KpiService } from "../kpi-dialog/kpi.service";
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {


  AllContracts = [];
  ActiveTileIndication: number = 2;
  columnmessege = "Approval request assigned for";

  totalPendingContractCount = 0;
  totalInitiatedContractCount = 0;
  totalPendingSignatureContractCount = 0;
  totalPendingReviewCount = 0;
  totalExpireCount = 0;
  totalExpiredCount = 0;
  totalnetWorth = 0;
  totalStatusCount = 0;
  totalAmount = 0;
  totalWorth = 0;
  worthAmount = []
  kpiData:any;
  chartOption: any;
  isLoading: boolean = true;
  public barChart: Chart;
  chart: any;

  constructor(
    public contractService: ContractService,
    public userService: UserService,
    public chartService: ChartService,
    private dialog: MatDialog,
    private kpiService: KpiService,
    private cdRef: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    try {
      await this.userService.getAllContractsForApprovalByLoggedInUser().then(() => {
        this.totalPendingContractCount =
          this.userService.pendingContractsForApproval.length;
        // this.AllContracts = this.userService.pendingContractsForApproval;
      });
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      await this.userService.getContractInitiatedByUser().then(() => {
        this.totalInitiatedContractCount =
          this.userService.initiatedContracts.length;
      });
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      await this.userService.getPendingSignContracts().then(() => {
        this.totalPendingSignatureContractCount =
          this.userService.pendingSignatureContracts.length;
      });
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      await this.userService.getAllContractsForReviewByLoggedInUser().then(() => {
        this.totalPendingReviewCount =
          this.userService.pendingContractsForReview.length;
      });
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      await this.userService.getExpiredContract(90).then(() => {
        this.totalExpiredCount = this.userService.expiredContracts.length
      });
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      await this.userService.getContractStatus().then(() => {
        this.totalStatusCount = this.userService.contractStatus.length
      })
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      this.totalAmount = await this.userService.getContractStatus();
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      this.userService.getExpireContract(30).then((value: any) => {
        this.totalWorth = value;
        this.totalExpireCount = this.userService.expireContracts.length;
      }).catch((error: any) => {
        console.error("Error fetching expire contract:", error);
      });
    } catch (error) {
      console.error('Error:', error);
    }

    try {
      this.chartService.getContractByType().subscribe((res: any) => {
        this.contractByType(res.contractsList);
      });
    } catch (error) {
      console.error('Error:', error);
    }

    if (this.totalPendingReviewCount > 0)
      this.getContractsCommanly(2);
    else
      this.getContractsCommanly();

    this.isLoading = false;

    this.kpiService.kpiData$.subscribe((data) => {
      if (data) {
        this.kpiData = data;
        this.cdRef.detectChanges(); 
      }
    });
  }


  getContractsCommanly(x: number = 0) {
    this.ActiveTileIndication = x;
    if (x == 0) {
      this.AllContracts = this.userService.initiatedContracts;
      this.columnmessege = "Initiated Contract is";
    } else if (x == 1) {
      this.AllContracts = this.userService.pendingSignatureContracts;
      this.columnmessege = "Pending Signature Contract is ";
    } else if (x == 2) {
      this.AllContracts = this.userService.pendingContractsForReview;
      this.columnmessege = "Review request assigned for";
    } else if (x == 3) {
      this.AllContracts = this.userService.pendingContractsForApproval;
      this.columnmessege = "Approval request assigned for";
    } else if (x == 4) {
      this.AllContracts = this.userService.expireContracts;
      this.columnmessege = "Expiring Contract in 30 day ";
    } else if (x == 5) {
      this.AllContracts = this.userService.expiredContracts;
      this.columnmessege = "Expired"
    } else if (x == 6) {
      this.AllContracts = this.userService.expireContracts;
      this.columnmessege = `Contracts Worth are Expiring in next 30 days`
    } else if (x == 7) {
      this.AllContracts = this.userService.contractStatus;
      this.columnmessege = '	Total Contract Value for all Contracts which are pending signatures.'
    } else if (x == 8) {

    }
    this.sortContracts();
  }
  sortContracts(): void {
    this.AllContracts.sort((a, b) => b.contractId - a.contractId); 
  }
  openApproveConfirmation(contractId, contractName): void {
    const dialogRef =
      this.dialog.open(TaskDialogComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        width: '50%',
        data: {
          contractId,
          contractName,
          activeTileIndication: this.ActiveTileIndication,
          initialize: () => this.ngOnInit()
        }
      });
  }


  contractByType(result: any) {
    let filteredDataValue = [];
    let filteredDataLabel = [];
  
    result.filter((obj) => {
      if (obj.value > 0) {
        filteredDataValue.push({
          value: obj.value,
          itemStyle: {
            borderRadius: [2, 2, 0, 0]
          }
        });
        filteredDataLabel.push(obj.key);
      }
    });
  
    this.chart = echarts.init(document.getElementById('barChart'));
    
    let barWidths = 'auto';
    if (filteredDataValue.length <= 2) {
        barWidths = '5%';
    } else if (filteredDataValue.length <= 5) {
        barWidths = '25%';
    }
    const option = {
      color: '#2d9297',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        textStyle: {
          fontFamily: 'Poppins'
        }
      },
      grid: {
        left: '4%',
        top: 25,
        right: '4%',
        bottom: 130,
        borderWidth: 1,
        borderColor: '#ccc',
        containLabel: false
      },
      xAxis: {
        boundaryGap: true,
        type: 'category',
        data: filteredDataLabel,
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          interval: 0, // Display all labels
          rotate: 45,
          width: 150,
          lineHeight: 20,
          overflow: 'truncate',
          textStyle: {
            fontFamily: 'Poppins',
            fontSize: 12
          }
        },
        nameTruncate: {
          maxWidth: 2,
          ellipsis: '...',
          placeholder: '.',
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          textStyle: {
            fontFamily: 'Poppins'
          }
        },
      },
      series: [{
        name: 'Direct',
        type: 'bar',
        data: filteredDataValue,
        animation: true,
        animationDuration: 2000,
        animationEasing: 'BounceIn',
        label: {
          show: true,
          position: 'top',
          color: 'black',
          textStyle: {
            fontFamily: 'Poppins'
          }
        },
        barWidth: barWidths
        // Adjust width for single bar
      }]
    };
  
    this.chart.setOption(option);
  }
  
}